'use strict';

var network = require('./network.js');

class NotFoundError extends network.NetworkError {
}

exports.NotFoundError = NotFoundError;
//# sourceMappingURL=not_found.js.map
